import printHtml from '@/mixins/printHtml'

const productionBottlingPrintBottling = {
  mixins: [printHtml],
  methods: {
    async printBottling(id, product, print) {
      const isProduct = !!product;
      const results =  await this.$apiCall(`query productionBottlingPrintBottling($id:ID!, $isProduct:Boolean!, $audit:Boolean!) {
                                              bottlingPreferences {
                                                bottleDuration,bottleProof
                                              }
                                              product(id:$id) @include(if:$isProduct) {
                                                name,description
                                                strength,caseSize
                                                bom {name,quantity,per,units,precision,lotTracking}
                                              }
                                              bottling(id:$id) @skip(if:$isProduct) {
                                                date,duration,siteName,completed,productName,dutyPaid
                                                bottles,caseSize,lot,tankName,strength,reduceInventory
                                                bom {name,units,quantity,precision,lot}
                                                comments
                                                audit @include(if:$audit) {userName,time,event}
                                              }
                                            }`,
                                          {id, isProduct, audit:this.$store.getters.company.allowAudit});
      if (results.error)
        return;

      const bottling = isProduct ? results.data.product : results.data.bottling;
      const preferences = results.data.bottlingPreferences;

      if (isProduct && product.quantity !== undefined) {
        bottling.bom.forEach(item => {
          let q = item.quantity;
          if (item.per === 'Bottle')
            q *= product.quantity * bottling.caseSize;
          else if (item.per === 'Case')
            q *= product.quantity;
          item.quantity = this.$roundNumber(q, item.precision)
        });
      }

      const lines = [`
        <style>
          @page {size:portrait}
          table {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px;table-layout:fixed}
          td {padding:5px;height:30px;position:relative}
          .title {font-weight:bold;text-align:center;font-size:150%;padding-bottom:40px}
          .subtitle {font-weight:medium;text-align:center;height:10px}
          .box {${isProduct ? 'border-bottom:thin solid #aaa':''}}
          .label {display:inline-block;top:-8px;position:absolute;xbackground-color:#fff;xpadding-left:5px;xpadding-right:5px;font-size:90%}
          .suffix {display:inline-block${isProduct ? ';float:right' : ''}}
          .placeholder {${isProduct ? 'color:#888' : ''}}
          .half-line {height:20px}
          .hint {text-align:center; font-size:9px}
          .inner-table {border:thin solid #ccc; padding:10px}
          .page-break {page-break-before: always}
          .incomplete {font-size:50px;opacity:0.2;text-align:center}
        </style>
        <table>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <thead>
            ${isProduct || bottling.completed ? '' : `<tr><td colspan="20" class="incomplete">INCOMPLETE</td></tr>`}
            <tr><td colspan="20" class="subtitle">${this.company.name}</td></tr>
            <tr><td colspan="20" class="title">Bottling ${isProduct ? bottling.name : bottling.productName}${!isProduct && bottling.dutyPaid?' (Duty-paid)':''}</td></tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="5" class="box"><div class="label">Date</div>
                <span class="placeholder">
                  ${isProduct?`${product.date ? this.$formatDateTime(product.date) : ''}`:this.$formatDateTime(bottling.date)}
                </span>
              </td>
              <td/>
              ${preferences.bottleDuration ? `<td colspan="4" class="box"><div class="label">Duration</div>${isProduct?'':this.$options.filters.duration(bottling.duration)}</td>` : '<td colspan="4"/>'}
              <td colspan="4"/>
              ${this.$store.getters.sites(true, {B265:true,B266:true}).length ? `<td colspan="6" class="box"><div class="label">Site</div>
                ${isProduct?product.siteName??'':bottling.siteName}
              </td>` : '<td colspan="6"/>'}
            </tr>
            <tr><td colspan="20"/></tr>
            ${bottling.description ? `<tr><td colspan="10">${bottling.description}</td></tr><tr><td colspan="20" class="half-line"/></tr>` : '<tr><td colspan="20"/></tr>'}
            <tr>
              <td colspan="3" class="box">
                <div class="label">Cases</div>
                ${isProduct ? (product.quantity !== undefined ? `<span class="placeholder">${product.quantity}</span>` : '') : Math.floor(bottling.bottles/bottling.caseSize)}
              </td>
              <td/>
              <td colspan="3" class="box">
                <div class="label">Bottles</div>
                ${isProduct ? (product.quantity !== undefined ? `<span class="placeholder">0</span>` : '') : bottling.bottles - Math.floor(bottling.bottles/bottling.caseSize)*bottling.caseSize}
              </td>
              <td/>
              <td colspan="3" class="box">
                <div class="label">Lot code</div>
                ${isProduct ? '' : bottling.lot}
              </td>
            </tr>
            <tr><td colspan="20"/></tr>
            <tr>
              <td colspan="7" class="box">
                <div class="label">From tank</div>
                ${isProduct ? '' : bottling.tankName}
              </td>
              <td/>
              ${preferences.bottleProof ? '' :
                `<td colspan="3" class="box">
                  <div class="label">Strength</div>
                  ${isProduct ? `<span class="placeholder">${this.$number(bottling.strength,2)}</span>` : this.$number(bottling.strength,2)}
                  <div class="suffix">% alc./vol.</div>
                  </td>`}
              <td/>
              <td colspan="9">
                ${isProduct ? 'Reduce remaining tank volume to zero? Y / N' : (bottling.reduceInventory ? 'Reduced remaining tank volume to zero' : '')}
              </td>
            </tr>
            <tr><td colspan="20" class="half-line"/></tr>

            <tr>
              <td colspan="20" class="inner-table">
                <table>

            <tr>
              <td colspan="8" class="half-line"><strong>Item</strong></td>
              <td/>
              <td colspan="6" class="half-line"><strong>Quantity</strong></td>
              <td/>
              <td colspan="4" class="half-line"><strong>Lot</strong></td>
            </tr>
        `];

      for (const item of bottling.bom) {
        lines.push(`
          <tr>
            <td colspan="8" class="box">${item.name}</td>
            <td/>
            <td colspan="6" class="box">
              ${isProduct ? (product.quantity !== undefined ? `<span class="placeholder">${this.$number(item.quantity, item.precision)}</span>` : '') : this.$number(item.quantity, item.precision)}
              <div class="suffix">${item.units}</div>
            </td>
            <td/>
            <td colspan="4" class="box">${isProduct?`${item.lotTracking?'':'n/a'}`:item.lot??''}</td>
          </tr>`);
        if (isProduct)
          lines.push(`
          <tr>
            <td colspan="9" class="half-line"/>
            <td colspan="6" class="half-line hint">
              ${this.$number(item.quantity, item.precision)} per ${item.per}
            </td>
          </tr>
        `);
      }
      if (isProduct)
        lines.push(`
          <tr>
            <td colspan="8" class="box"></td>
            <td/>
            <td colspan="6" class="box"></td>
            <td/>
            <td colspan="4" class="box"></td>
          </tr>`);
      lines.push(`
          </table>
      </td>
    </tr>

        <tr><td/></tr>
        <tr>
          <td colspan="20" class="box" style="height:60px"><div class="label">Comments</div>
          ${isProduct?'':bottling.comments}
          </td>
        </tr>`);

      if (isProduct)
        lines.push(`
        <tr><td/></tr>
        <tr><td/></tr>
        <tr>
          <td colspan="8" class="box"><div class="label">Performed by</div><div class="placeholder">${product.performBy}</div></td>
          <td/>
          <td colspan="8" class="box"><div class="label">Signature</div></td>
        </tr>`);

      else if (this.$store.getters.company.allowAudit) {
        lines.push(`<tr>
                      <td colspan="4"><strong>Date</strong></td>
                      <td/>
                      <td colspan="5"><strong>User</strong></td>
                      <td/>
                      <td colspan="9"><strong>Action</strong></td>
                    </tr>`);
        for (const audit of bottling.audit)
          lines.push(`<tr>
                        <td colspan="4">${this.$formatDateTime(audit.time)}</td>
                        <td/>
                        <td colspan="5">${audit.userName}</td>
                        <td/>
                        <td colspan="9">${audit.event}</td>
                      </tr>`);
      }

      lines.push(`
        </tbody>
        </table>
      `);

      if (print)
        this.printHtml('Bottling',lines.join(''));
      else
        return lines;
    }
  }
}

export default productionBottlingPrintBottling;